// src/lib/utils.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/components/ui/skeleton.tsx
import { jsx } from "react/jsx-runtime";
function Skeleton({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("animate-pulse rounded-md bg-muted", className),
      ...props
    }
  );
}

// src/components/shell/LoadingState.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function LoadingState({ rows = 3, className }) {
  return /* @__PURE__ */ jsx2("div", { className: cn("space-y-3", className), children: Array.from({ length: rows }, (_, i) => /* @__PURE__ */ jsx2(Skeleton, { className: "h-12 w-full" }, i)) });
}
export {
  LoadingState
};
//# sourceMappingURL=LoadingState.js.map